import dayjs from "dayjs";
import { Box, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import FormatService from "../../services/formatService";

interface DatePickerUpdaterProps {
  label: string;
  value: string | undefined;
  setValue: Function;
}

const tfLabelProps = {
  sx: {
    fontFamily: "Manrope",
    color: "#6f7d95",
    fontSize: "1rem !important",
    fontWeight: 600,
    "&.MuiOutlinedInput-notchedOutline": {
      fontSize: "28px",
      border: "0px !important",
    },
  },
};

const DatePickerUpdater = ({
  label,
  setValue,
  value,
}: DatePickerUpdaterProps) => {
  const { storeDateFormat } = FormatService();

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="body1" sx={tfLabelProps.sx}>
        {label}
      </Typography>

      <DatePicker
        value={dayjs(value)}
        onChange={(newValue) => setValue(storeDateFormat(newValue))}
        format="DD/MM/YYYY"
        sx={{
          width: "100%",
          backgroundColor: "#f4f6f9 !important",
          borderRadius: "5px !important",
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "0px",
          },
          "& .MuiOutlinedInput-input": {
            fontFamily: "Manrope",
            color: "#6f7d95",
            fontSize: "1rem !important",
          },
        }}
      />
    </Box>
  );
};

export default DatePickerUpdater;
